import { Grid, FormControlLabel } from '@mui/material';

// Styles
import {
    Text,
    Container,
    ContainerGroupOne,
} from './styles'
import { AntSwitch, CustomTextField, CustomFormControl, CustomButtonV2, CustomChipStatus } from '../../pages/styles';

import { useTranslation } from 'react-i18next'

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../Context/PermissionsContext';
import { SaveOutlined } from '@mui/icons-material';

export const InactivityTime = ({ data, errors, loading, handleChange, handleState, handleInactivityTime }) => {
    const { t } = useTranslation();
    const ability = useAbility(AbilityContext);

    return (
        <Container>
			<Grid container spacing={2}>

				<Grid item xs={12}>
					<FormControlLabel
						disabled={loading}
						sx={{ pl: 2 }}
						control={
							<AntSwitch
								checked={data.isActive}
								onChange={() => handleState(!data.isActive)}
								inputProps={{ 'aria-label': 'controlled' }}
							/>
						}
						label={
							<CustomChipStatus
								enabled={data.isActive}
								label={data.isActive ? t('system.inactivityTimes.active') : t('system.inactivityTimes.inactive')}
								sx={{ ml: 1 }}
							/>
						}
					/>
				</Grid>
				
				<Grid item xs={12} sm={6} md={4} xl={2}>
					<CustomTextField
						label={t('system.inactivityTimes.inMinutes')}
						type={'number'}
						value={data.time}
						onChange={e => handleChange(e, 'time')}
						onInput={(e) => {
							e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
						}}
						sx={{ width: '100%' }}
						disabled={loading || !data.isActive}
						error={errors.time.hasError}
						helperText={errors.time.message}
					/>
				</Grid>

				<Grid item xs={12}>
					<CustomFormControl>{t('system.inactivityTimes.message')}</CustomFormControl>
					<CustomTextField
						multiline
						fullWidth
						rows={4}
						value={data.timeMessage}
						onChange={e => handleChange(e, 'timeMessage')}
						disabled={loading || !data.isActive}
						error={errors.timeMessage.hasError}
						helperText={errors.timeMessage.message}
					/>
				</Grid>
				
				<Grid item xs={12}>
					{ability.can("UpdateInactivityTime") &&
						<ContainerGroupOne isDown={true}>
							<CustomButtonV2
								btnType="primary"
								sx={{ width: '120px' }}
								onClick={() => handleInactivityTime()}
								disabled={loading}
								startIcon={<SaveOutlined/>}
							>
								{t('common.save')}
							</CustomButtonV2>
						</ContainerGroupOne>
					}
				</Grid>

				<Grid item xs={12}>
					{errors.general.hasError &&
						<Grid item xs={8}>
							<Text>{errors.general.message}</Text>
						</Grid>
					}
				</Grid>
			</Grid>
        </Container>
    )
}